import { render, staticRenderFns } from "./OrderPrintDialog.vue?vue&type=template&id=70ee4870&scoped=true"
import script from "./OrderPrintDialog.vue?vue&type=script&lang=js"
export * from "./OrderPrintDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderPrintDialog.vue?vue&type=style&index=0&id=70ee4870&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee4870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ee4870')) {
      api.createRecord('70ee4870', component.options)
    } else {
      api.reload('70ee4870', component.options)
    }
    module.hot.accept("./OrderPrintDialog.vue?vue&type=template&id=70ee4870&scoped=true", function () {
      api.rerender('70ee4870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderPrintDialog.vue"
export default component.exports